<template>
  <div class="pay-login water-mark">
    <div class="logo" v-if="step == 1 || step == 2"></div>
    <form
      action
      class="form"
      v-if="step == 1"
      @submit.prevent="salaryQueryPassword"
    >
      <div class="form-item">
        <div class="form-item_label">手机号</div>
        <van-field
          type="number"
          maxlength="11"
          clearable
          v-model="step1Form.mobile"
          placeholder="输入手机号"
        />
      </div>
      <div class="form-item">
        <div class="form-item_label">验证码</div>
        <van-field
          type="number"
          clearable
          placeholder="输入验证码"
          maxlength="6"
          v-model="step1Form.smsCode"
        >
          <span
            slot="button"
            class="verificat-code"
            id="senCode"
            @click.stop="getVerificat"
            >获取验证码</span
          >
        </van-field>
      </div>
      <div class="form-item">
        <div class="form-item_label">设置密码</div>
        <van-field
          maxlength="6"
          clearable
          type="password"
          inputmode="numeric"
          @keyup="inputChange"
          v-model="step1Form.passWord1"
          placeholder="6位数字查询密码"
        />
      </div>
      <div class="form-item">
        <div class="form-item_label">确认密码</div>
        <van-field
          clearable
          maxlength="6"
          @keyup="inputChange"
          type="password"
          inputmode="numeric"
          placeholder="再次确认密码"
          v-model="step1Form.passWord2"
        ></van-field>
      </div>
      <div style="margin: 50px 10px 30px 10px">
        <van-button
          round
          block
          class="button"
          type="info"
          :disabled="isSubmit"
          :loading="isSubmit"
          >新建密码</van-button
        >
      </div>
      <div class="desc">
        <span>温馨提示：</span
        >首次查询工资条需要使用钉钉绑定的手机号通过验证，并创建六位数字的查询密码
      </div>
    </form>
    <form action class="form" v-if="step == 2" @submit.prevent="querySalary">
      <div class="form-item">
        <div class="form-item_label">查询密码</div>
        <van-field
          maxlength="6"
          clearable
          type="password"
          inputmode="numeric"
          @keyup="inputChange"
          v-model="step3Form.passWord"
          placeholder="6位数字查询密码"
        >
          <span
            slot="button"
            class="verificat-code"
            id="senCode"
            @click.stop="forgetPassword"
            >忘记密码</span
          >
        </van-field>
      </div>
      <div style="margin: 50px 10px 30px 10px">
        <van-button
          round
          block
          class="button"
          type="info"
          :disabled="isGoLoanding"
          :loading="isGoLoanding"
          >查询</van-button
        >
      </div>
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import { Button, Field, Toast } from 'vant';
import {
  hasPassword,
  codeSend,
  salaryQueryPassword,
  querySalary,
} from '../../api/pay';
import { geturlParams } from '../../utils/index.js';

Vue.use(Button)
  .use(Field)
  .use(Toast);

export default {
  data() {
    return {
      timer: null,
      isVerificatDisabled: false,
      isSubmit: false,
      isGoLoanding: false,
      step: '',
      step1Form: {
        mobile: '',
        smsCode: '',
        passWord1: '',
        passWord2: '',
      },
      step3Form: {
        passWord: '',
      },
    };
  },
  mounted() {
    this.hasPassword();
  },
  methods: {
    hasPassword() {
      hasPassword({})
        .then(res => {
          if (typeof res !== 'boolean') {
            Toast('系统异常 请稍后再试');
            this.step = 1;
          } else {
            this.step = res ? 2 : 1;
          }
        })
        .catch(err => {
          this.step = 1;
          Toast(err.message || '系统异常 请稍后再试');
        });
    },

    inputChange() {
      this.step3Form.passWord = this.step3Form.passWord.replace(/[^\d]/g, '');
      this.step1Form.passWord1 = this.step1Form.passWord1.replace(/[^\d]/g, '');
      this.step1Form.passWord2 = this.step1Form.passWord2.replace(/[^\d]/g, '');
    },

    countDown(id, n = 60) {
      const element = document.querySelector(id);
      element.className += ' disabled';
      element.innerText = `${n}秒后重发`;
      this.timer = setInterval(() => {
        n--;
        element.innerText = `${n}秒后重发`;
        if (n <= 0) {
          clearInterval(this.timer);
          this.isVerificatDisabled = false;
          element.innerText = '获取验证码';
          element.className = element.className.replace(
            /^\s+|\s+disabled/g,
            ''
          );
        }
      }, 1000);
    },

    getVerificat() {
      this.step1Form.smsCode = '';
      if (this.isVerificatDisabled) return false;
      if (!this.step1Form.mobile)
        return Toast({ position: 'top', message: '请输入手机号' });
      this.isVerificatDisabled = true;
      codeSend({ mobile: this.step1Form.mobile })
        .then(res => {
          this.countDown('#senCode');
          Toast.success('发送验证码成功');
        })
        .catch(err => {
          Toast(err.message || '验证码发送失败 请稍后再试');
          clearInterval(this.timer);
          this.isVerificatDisabled = false;
          const element = document.querySelector('#senCode');
          element.innerText = '获取验证码';
          element.className = element.className.replace(
            /^\s+|\s+disabled/g,
            ''
          );
        });
    },

    salaryQueryPassword() {
      if (!this.step1Form.mobile)
        return Toast({ position: 'top', message: '请输入手机号' });
      if (!this.step1Form.smsCode)
        return Toast({ position: 'top', message: '请输入验证码' });
      if (!this.step1Form.passWord1)
        return Toast({ position: 'top', message: '请输入6位查询密码' });
      if (this.step1Form.passWord1.length != 6)
        return Toast({ position: 'top', message: '密码最少6位' });
      if (!this.step1Form.passWord2)
        return Toast({ position: 'top', message: '请再次输入密码' });
      if (this.step1Form.passWord1 !== this.step1Form.passWord2)
        return Toast({ position: 'top', message: '两次输入的密码不一致' });
      this.isSubmit = true;
      const params = {
        mobile: this.step1Form.mobile,
        password: this.step1Form.passWord2,
        smsCode: this.step1Form.smsCode,
      };
      salaryQueryPassword(params)
        .then(res => {
          if (res && res.code == 1) {
            Toast.fail(res.message || '新建密码失败 请稍后再试');
            this.isSubmit = false;
            return;
          }
          Toast.success('创建成功');
          setTimeout(() => {
            this.step = 2;
            this.step1Form.mobile = '';
            this.step1Form.smsCode = '';
            this.step1Form.passWord1 = '';
            this.step1Form.passWord2 = '';
            this.isSubmit = false;
          }, 1000);
        })
        .catch(err => {
          this.isSubmit = false;
          Toast(err.message || '新建密码失败 请稍后再试');
        });
    },
    querySalary() {
      if (!this.step3Form.passWord || this.step3Form.passWord.length != 6)
        return Toast({ position: 'top', message: '请输入6位查询密码' });
      this.isGoLoanding = true;
      let year = new Date().getFullYear();
      let month = new Date().getMonth();
      if (month === 0) {
        year -= 1;
        month = 12;
      }
      const date = `${year}-${
        month.toString().length == 1 ? `0${month}` : month
      }`;
      const params = {
        password: this.step3Form.passWord,
        salaryMonth: date,
      };
      querySalary(params)
        .then(res => {
          if (!res) return Toast(err.message || '查询失败 请稍后再试');
          if (res.code == 1) {
            this.isGoLoanding = false;
            Toast(res.message || '查询失败 请稍后再试');
            return;
          }
          window.sessionStorage.setItem('SALARY_DATA', JSON.stringify(res));
          window.sessionStorage.setItem('SALARY_PW', this.step3Form.passWord);
          window.sessionStorage.setItem('SALARY_DATE', params.salaryMonth);
          let parmobj = geturlParams();
          let path = parmobj['Api-Version']
            ? `/pay/search?Api-Version=${parmobj['Api-Version']}&token=${parmobj.token}`
            : '/pay/search';
          setTimeout(() => {
            this.$router.push({
              path,
            });
            this.isGoLoanding = false;
          }, 500);
        })
        .catch(err => {
          Toast(err.message || '查询失败 请稍后再试');
          this.isGoLoanding = false;
        });
    },

    forgetPassword() {
      this.step = 1;
    },
  },
};
</script>

<style lang="scss">
.pay-login {
  margin: 0 50px;
  .logo {
    height: 200px;
    background: url(https://web-data.zmlearn.com/image/9Prb7NjdqXG33muLfMpQHn/logologin.png)
      no-repeat center bottom;
    background-size: auto 100px;
    margin-bottom: 80px;
  }
  .desc {
    > span {
      font-size: 28px;
      color: #252629;
      font-weight: 500;
    }
    padding: 30px 20px;
    line-height: 50px;
    font-size: 26px;
    color: #606266;
  }
  .verificat-code {
    font-size: 28px;
    color: #666;
    padding-right: 5px;
  }
  .form-item {
    display: flex;
    align-items: center;
    margin: 30px;
    .form-item_label {
      font-size: 32px;
      color: #333;
      width: 220px;
    }
    .van-field__control {
      padding-left: 5px;
      color: #333;
      font-size: 15px;
    }
    .van-field__control::-webkit-input-placeholder {
      color: #ccc;
    }
    .van-field {
      padding: 10px 0;
      border-bottom: 0.5px solid #cbcccf;
    }
  }
  .button {
    width: 100%;
    background: #f32735;
    color: #fff;
    font-size: 34px;
    border: 1px solid #f32735;
  }
}
</style>
